export default {
  state: {
    unitData: {},
  },

  getters: {
    getUnitData(state) {
      return state.unitData;
    },
  },

  mutations: {
    setUnitData(state, data) {
      const isNull = data === null;

      state.unitData = {
        id: !isNull ? data.id : "",
        nome: !isNull ? data.nome : "",
        razao_social: !isNull ? data.razao_social : "",
        cnes: !isNull ? data.cnes : "",
        cnpj: !isNull ? data.cnpj : "",
        nome_responsavel_unidade: !isNull ? data.nome_responsavel_unidade : "",
        logradouro: !isNull ? data.logradouro : "",
        numero: !isNull ? data.numero : "",
        complemento: !isNull ? data.complemento : "",
        bairro: !isNull ? data.bairro : "",
        cep: !isNull ? data.cep : "",
        telefone_principal: !isNull ? data.telefone_principal : "",
        telefone_opcional: !isNull ? data.telefone_opcional : "",
        celular: !isNull ? data.celular : "",
        email: !isNull ? data.email : "",
        municipio_id: !isNull ? data.municipio_id : "",
      };
    },
  },

  actions: {
    changeUnitData(context, infos) {
      context.commit("setUnitData", infos);
    },
  },
};
